import DownloadIcon from "PFIcons/download.svg";
import React from "react";

import css from "./download_button.module.scss";

type DownloadButtonProps = {
  downloadUri: string;
};

const DownloadButton = ({ downloadUri }: DownloadButtonProps): JSX.Element => (
  <a className={css.downloadButton} href={downloadUri} target="_blank" rel="noreferrer" download>
    <DownloadIcon width={14} height={16} />
  </a>
);

export default DownloadButton;
